import axios from 'axios'
import Constants from '../constants'

export default {
  getCourses: (lang) => {
    return new Promise((resolve) => {
      axios.get('modelCourse', { params: { id: Constants.API_ID, language: lang } })
        .then(payload => {
          resolve(payload.data.courses)
        })
    })
  }
}
